import React, { useState } from "react";

// components imports
import CircularLoader from "../../../../Components/CircularLoader/CircularLoader";

// apis imports
import { storeStorageMap } from "../../../../services/WarehouseServices/storageMap.services";

// library imports
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    bgcolor: "background.paper",
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
};

export default function AddGraphModal({
    open,
    setOpen,
    setSnack,
    setStorageMaps
}) {
    const { t } = useTranslation(["warehouse", "common"]);
    const [loader, setLoader] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        rows: 50,
        column: 50,
    });

    const [errors, setErrors] = useState({
        name: "",
        rows: "",
        column: "",
    });

    const handleClose = () => {
        setOpen(false);
    };

    const handleCancel = () => {
        handleClose();
    };

    const handleFieldChange = (name, value) => {
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" }); // Clear errors when user starts typing
    };

    const validateFields = () => {
        let valid = true;
        const newErrors = {};

        if (!formData.name.trim()) {
            newErrors.name = t("locations.nameIsRequired");
            valid = false;
        }

        if (!formData.rows || formData.rows <= 0) {
            newErrors.rows = t("locations.rowsMustBeGreaterThan0");
            valid = false;
        }

        if (!formData.column || formData.column <= 0) {
            newErrors.column = t("locations.columnsMustBeGreaterThan0");
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const handleSave = async () => {
        if (!validateFields()) return;

        setLoader(true);
        const response = await storeStorageMap(formData);
        setLoader(false);

        if (response?.data?.success) {
            setStorageMaps((prevMaps) => [response?.data?.result, ...prevMaps]);
            setSnack((snack) => ({
                ...snack,
                open: true,
                text: t("locations.graphAddedSuccessfully"),
                severity: "success",
            }));
            handleClose();
        } else {
            setSnack((snack) => ({
                ...snack,
                open: true,
                text: response?.data?.message || t("common:messages.somethingWentWrong"),
                severity: "error",
            }));
        }
    };

    return (
        <div>
            <Modal
                open={open}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
            >
                <Box
                    sx={{ ...style, width: "100%", maxWidth: "600px", maxHeight: "90vh", overflow: "auto" }}
                >
                    <h4 id="child-modal-title" className="text-center mt-2 mb-4">
                        {t("locations.addNewGraph")}
                    </h4>

                    <div className="flex justify-between my-3">
                        <div className="flex-1 mr-2">
                            <TextField
                                label={t("locations.name")}
                                type="text"
                                value={formData?.name}
                                onChange={(e) => handleFieldChange("name", e.target.value)}
                                placeholder={t("locations.name")}
                                sx={{
                                    width: "100%",
                                    input: { font: "menu" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size="small"
                                error={!!errors.name}
                                helperText={errors.name}
                            />
                        </div>
                    </div>

                    <div className="flex justify-between my-3">
                        <div className="flex-1 mr-2">
                            <TextField
                                label={t("locations.rows")}
                                type="number"
                                value={formData?.rows}
                                onChange={(e) => handleFieldChange("rows", e.target.value)}
                                placeholder={t("locations.rows")}
                                sx={{
                                    width: "100%",
                                    input: { font: "menu" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size="small"
                                error={!!errors.rows}
                                helperText={errors.rows}
                            />
                        </div>
                    </div>

                    <div className="flex justify-between my-3">
                        <div className="flex-1 mr-2">
                            <TextField
                                label={t("common:table.columns")}
                                type="number"
                                value={formData?.column}
                                onChange={(e) => handleFieldChange("column", e.target.value)}
                                placeholder={t("common:table.columns")}
                                sx={{
                                    width: "100%",
                                    input: { font: "menu" },
                                }}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                size="small"
                                error={!!errors.column}
                                helperText={errors.column}
                            />
                        </div>
                    </div>

                    <div style={{ display: "flex", justifyContent: "end" }} className="addnotes_fulfilment_btn">
                        <Button onClick={handleSave} variant="contained" size="small">
                            {loader ? <CircularLoader /> : t("common:actions.add")}
                        </Button>
                        <Button
                            onClick={handleCancel}
                            variant="contained"
                            color="error"
                            size="small"
                            style={{ marginLeft: "5px" }}
                        >
                            {t("common:actions.cancel")}
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}
